"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var retrieveStyle = function retrieveStyle(theme) {
  var tabletMobile = (0, _seamlessImmutable.getIn)(theme, ['Media', 'tabletMobile']);
  return {
    base: _defineProperty({
      border: (0, _seamlessImmutable.getIn)(theme, ['UTCard', 'base', 'border'], 0),
      borderRadius: (0, _seamlessImmutable.getIn)(theme, ['UTCard', 'base', 'borderRadius'], '4px'),
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTCard', 'base', 'backgroundColor'], _colors["default"].cardBackground),
      boxShadow: (0, _seamlessImmutable.getIn)(theme, ['UTCard', 'base', 'boxShadow'], "1px 1px 3px 0 ".concat(_colors["default"].cardShadow1, ", -0.5px -0.5px 2px 0 ").concat(_colors["default"].cardShadow2)),
      boxSizing: 'border-box',
      display: 'flex',
      overflow: 'hidden',
      padding: (0, _seamlessImmutable.getIn)(theme, ['UTCard', 'base', 'padding'], '15px 20px')
    }, tabletMobile, {
      padding: (0, _seamlessImmutable.getIn)(theme, ['UTCard', 'base', 'tabletMobile', 'padding'], '10px')
    }),
    flat: {
      boxShadow: 'none',
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTCard', 'flat', 'backgroundColor'], _colors["default"].white)
    }
  };
};

exports.retrieveStyle = retrieveStyle;